import { useAiChatContext } from "./AiChatContext";

export function useAiChat() {
  return useAiChatContext();
}

export default useAiChat;
